module.exports = "/assets/data/caead33b193b805a724552fb93ce1e5d-BT76.data.json";